import { Component, ViewChild, ViewContainerRef, OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { AssetDetails } from "../../types/macs-asset.type";
import { RegionService } from "../../services/region.service";
import { Platform } from "ionic-angular";
import { NetworkStatusService } from "../../services/network-status.service";
import { SharedConstants } from "../../services/shared/shared-constants";

interface GetAssetPathResponse {
  assetPath: string;
}

@Component({
  selector: "video-page",
  templateUrl: "video.html"
})
export class VideoPage {
  @ViewChild("video", { read: ViewContainerRef })
  pltformVersion: any;

  showContent = true;
  onlineStatus: boolean;
  constructor(
    private router: Router,
    public regionService: RegionService,
    public plt: Platform,
    public networkService: NetworkStatusService
  ) {
    this.showContent = true;
    this.networkService.online$.subscribe(res => {
      this.onlineStatus = res;
    });
  }

  next(): void {
    this.onlineStatus
      ? this.router.navigate(["visual-challenges"])
      : this.networkService.presentToast(SharedConstants.networkErrorMessage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/video/video.ts